module.exports = __webpack_public_path__ + "img/Android.fc382a08.png";